import { log, getTargetInfo } from './utils.js';
import { state, setLoading, __staticDispatch } from './globals.js';
import { coreDidReceiveMessage, coreReceive } from './core.js';
import { delegateCallToCore, clientDidReceiveMessage } from './client.js';
import { IS_CLIENT, SHOW_FRAME, IS_DEBUG, IS_SANDBOX } from './config.js';
export function sandboxInit(options) {
    log(`Sandbox Init (client=${IS_CLIENT}`);
    if (state.frame) {
        log(`Double initialization detected.`);
        return;
    }
    if (IS_CLIENT) {
        const iframe = document.createElement('iframe');
        iframe.src = `${options.sandbox}?tsifrpc_referrer=${encodeURIComponent(window.location.origin)}`;
        iframe.id = '__webview';
        iframe.title = options.sandbox_title ?? 'Sandbox';
        iframe.name = `${options.sandbox_title ?? 'Sandbox'} (${Date.now()})`;
        iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        log(`iframe.src = ${options.sandbox}`);
        if (!IS_DEBUG || !SHOW_FRAME) {
            iframe.width = '0';
            iframe.height = '0';
            iframe.style.border = '0';
        }
        document.body.appendChild(iframe);
        state.frame = iframe.contentWindow;
        state.targetOrigin = (new URL(options.sandbox)).origin;
        setLoading(new Promise((resolve) => {
            iframe.onload = function (_) {
                resolve();
            };
            setLoading(null);
        }));
        log(`Client initialized: (sandbox=${state.targetOrigin})`);
    }
    else {
        state.frame = window.parent;
        const params = new URLSearchParams(window.location.search);
        state.targetOrigin = params.get('tsifrpc_referrer');
        log(`Sandbox initialized: (referrer=${state.targetOrigin})`);
        const loaded = document.createElement('p');
        loaded.innerHTML = "Environment loaded!";
        document.body.appendChild(loaded);
    }
    if (!state.listener) {
        state.listener = (event) => {
            if (event.origin !== state.targetOrigin) {
                log(`Received event from ${event.origin}. Dismissing (expected ${state.targetOrigin})`);
                return;
            }
            log("received message");
            log(event.data);
            if (IS_CLIENT) {
                clientDidReceiveMessage(event);
            }
            else {
                coreDidReceiveMessage(event);
            }
        };
        window.addEventListener("message", state.listener, false);
    }
}
export const _minifiedClazzNames = {};
export function runInSandboxWithOptions(options) {
    if (IS_SANDBOX && !state.frame) {
        sandboxInit({
            sandbox: window.origin,
            debug: process?.env?.DEBUG == '1'
        });
    }
    return (target, propertyKey, descriptor) => {
        if (!propertyKey) {
            throw new Error("rpcAvailable only available in `method` context.");
        }
        const [clazzName, isStatic] = getTargetInfo(target);
        if (!isStatic) {
            throw new Error("runInSandbox only available in `static` context.");
        }
        if (!target.__rpc) {
            target.__rpcStatic = isStatic;
            target.__rpc = {};
            target.__dispatch = {};
            if (!_minifiedClazzNames[clazzName]) {
                _minifiedClazzNames[clazzName] = Object.keys(_minifiedClazzNames).length;
            }
            target.__minifiedClazzname = _minifiedClazzNames[clazzName];
            __staticDispatch[target.__minifiedClazzname] = target;
            if (IS_DEBUG) {
                log(`[CLASS] ${clazzName} => ${target.__minifiedClazzname} (static=${isStatic})`);
                log(_minifiedClazzNames);
            }
        }
        const assignedName = `${Object.keys(target.__rpc).length}`;
        target.__rpc[assignedName] = propertyKey;
        if (IS_DEBUG) {
            log(`[FUNC] ${propertyKey} => ${assignedName}`);
        }
        overrideInstanceOrStaticMethod(descriptor, target, assignedName, options);
    };
}
export const runInSandbox = runInSandboxWithOptions();
function overrideInstanceOrStaticMethod(descriptor, target, assignedName, options) {
    if (IS_CLIENT) {
        descriptor.value = delegateCallToCore(target, assignedName, options);
    }
    else {
        if (!target.__recv) {
            target.__recv = coreReceive;
        }
        if (!target.__args) {
            target.__args = {};
        }
        target.__args[assignedName] = descriptor.value.length;
    }
}
